<!--
 * @Description  : 温馨提示
-->

<template minapp="mpx" xlang="wxml">
<view wx:if="{{content !=null && content.length > 0}}">
  <view wx:if="{{from==='success'}}" class="es-card__success">
    <es-icon color="#1473FF" name="exclamation-circle" size="14"/>
    <view>
      <view class="es-card__success-title">{{title}}</view>
      <view wx:for="{{content}}" wx:key="index" class="es-card__success-content">
        {{item}}
      </view>
    </view>
  </view>

  <order-common-card wx:else bind:sideClick="toPurchaseNotice" title="{{title}}" sideTitle="查看详情" sideIcon hideDivider>
    <view wx:for="{{content}}" wx:key="index" class="es-card__content">
      {{index+1}}.{{item}}
      <view class="es-card__sizebox"></view>
    </view>
  </order-common-card>
</view>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  import { innerRouter, pagePath } from "@/common/jump";

  createComponent({
    props: {
      title: {
        type: String,
        value: '温馨提示'
      },
      content: {
        type: Array,
        value: []
      },
      showNum: Boolean,
      from: String
    },
    methods: {
      toPurchaseNotice() {
        innerRouter.push(pagePath().ICKETPURCHASENOTICE)
      }
    }
  })
</script>

<style scoped lang="stylus" src="./style.styl"></style>

<script name="json">
  module.exports = {
    component: true,
    usingComponents: {
      'order-common-card': '../order-common-card',
    }
  }
</script>